export function addToStorage(key, value) {
    return localStorage.setItem(key, JSON.stringify(value))
}

export function getFromStorage(key) {
    return JSON.parse(localStorage.getItem(key));
}